export default function getResource(label, vars = []) {
    const resources = {
        addAllToBasket: 'Add All to Basket',
        change: 'Change',
        currentProduct: 'Current Product',
        estimatedPrice: 'Total price:',
        frequentlyBoughtTogether: 'Frequently Bought Together'
    };
    return resources[label];
}
